<template>
  <ion-list>
    <ion-list-header>People</ion-list-header>
    <ion-item lines="none"> 
      <ion-avatar v-for="(match, index) in matches" :key="index" class="new">
        <img :src="match.photoURL" v-if="match.photoURL" />
      </ion-avatar>
  
    </ion-item>   
  </ion-list>
  
</template>

<script>
import { db } from "../main";

export default {
  data() {
    return {
      matches: [],
      unsubscribe: Function
    };
  },
  props: {
    id: String
  },
  created() {
    this.unsubscribe = db
      .collection("/trips")
      .doc(this.id)
      .collection("matches")
      .onSnapshot(changes => {
        changes.docChanges().forEach(change => {
          if (change.type === "added") {
            this.matches.push(change.doc.data());
            //console.log("New city: ", change.doc.data());
          }
          if (change.type === "modified") {
            console.log("Modified city: ", change.doc.data());
          }
          if (change.type === "removed") {
            console.log("Removed city: ", change.doc.data());
            this.matches.filter(el => el.user, change.doc.data().user);
          }
        });
        //console.log(changes);
      });
  },
  destroyed() {
    this.unsubscribe();
  }
};
</script>

<style scoped>
.avatar-list {
  width: 100vw;
  display: flex;
}
.new {
  border-color: #7044ff;
  border-width: 2px;
  border-style: solid;
}
</style>
